import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { getSingleLead } from "../slices/leads/leadManagementSlice";
import { AppDispatch } from "../slices/store";
import { useParams } from "react-router-dom";
import { clearFileResource, getFileResource } from "../slices/users/userManagementSlice";
import { scrollToTop } from "../utils/helpers/helperMethods/scrollToTop";
import { useSelectedLead } from "../slices/leads/selector";

export const useLeadData = () => {
  const { id } = useParams<{ id: string }>();
  const dispatch = useDispatch<AppDispatch>();
  const selectedLead = useSelectedLead();
  const apiUrl = process.env.REACT_APP_INFINITYS_API+"/api";

  useEffect(() => {
    if (!apiUrl) {
      console.error("REACT_APP_INFINITYS_API is not defined");
      return;
    }

    if (!id) return;

    dispatch(clearFileResource());

    const reqRequests = {
      url: apiUrl,
      accessToken: localStorage.getItem("AccessToken") || "llll",
      id,
    };

    dispatch(getSingleLead(reqRequests));

    scrollToTop();
  }, [id, dispatch, apiUrl]);

  useEffect(() => {
    if (!selectedLead?.id) return;

    const params = {
      accessToken: localStorage.getItem("AccessToken") || "llll",
      Reference: 2,
      ReferenceId: selectedLead.id,
      url: apiUrl,
    };

    dispatch(getFileResource(params));
  }, [selectedLead?.id, dispatch, apiUrl]);

  return { selectedLead };
};